module.exports = {"451223100":"凤城镇","451223101":"长洲镇","451223102":"三门海镇","451223201":"砦牙乡","451223203":"乔音乡","451223205":"金牙瑶族乡","451223207":"中亭乡","451223208":"平乐瑶族乡","451223209":"江洲瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451223.json
// module id = 2162
// module chunks = 0